import { createFeatureFlagHook } from './use-feature-flag';

export { FEATURE_FLAG_MAP as SCHEDULE_FF_MAP } from './feature-flag-registry';

export const useWaitlistDirectSchedulingFeatureFlag = createFeatureFlagHook('SCHEDULE_WAITLIST_DIRECT_SCHEDULING');
export const useCalendarColumnsReorderingFeatureFlag = createFeatureFlagHook('SCHEDULE_CALENDAR_COLUMNS_REORDERING');
export const useScheduleRequestEventsV3FeatureFlag = createFeatureFlagHook('SCHEDULE_CALENDAR_REQUEST_EVENTS_V3');
export const useCalendarBlockUIFeatureFlag = createFeatureFlagHook('SCHEDULE_CALENDAR_BLOCK_UI', 'ANY');
export const useCalendarAppointmentsReorderingFeatureFlag = createFeatureFlagHook(
  'SCHEDULE_CALENDAR_APPOINTMENTS_REORDERING'
);
export const useCalendarExpandCollapseFeatureFlag = createFeatureFlagHook('SCHEDULE_CALENDAR_EXPAND_COLLAPSE');
export const useScheduleRequestsWidgetFeatureFlag = createFeatureFlagHook('SCHEDULE_REQUESTS_WIDGET');
